import { BenefitPrice } from '../types';

type BenefitId = string;

export class ActiveBenefits {
    public lowestActiveBenefitPrice?: BenefitPrice;
    private activeBenefits = new Map<BenefitId, BenefitPrice>();

    public add(benefitId: BenefitId, price: BenefitPrice) {
        this.activeBenefits.set(benefitId, price);
        if (!this.lowestActiveBenefitPrice || price.lowestPrice < this.lowestActiveBenefitPrice.lowestPrice) {
            this.lowestActiveBenefitPrice = price;
        }
    }

    public remove(benefitId: BenefitId) {
        this.activeBenefits.delete(benefitId);

        if (this.activeBenefits.size > 0) {
            this.lowestActiveBenefitPrice = this.calculateCurrentLowestPrice();
            return;
        }

        this.lowestActiveBenefitPrice = undefined;
    }

    private calculateCurrentLowestPrice() {
        const benefitPrices = Array.from(this.activeBenefits.values());
        return benefitPrices.reduce(this.keepLowestPrice);
    }

    private keepLowestPrice(benefit1: BenefitPrice, benefit2: BenefitPrice): BenefitPrice {
        return benefit1.lowestPrice < benefit2.lowestPrice ? benefit1 : benefit2;
    }
}
